'use client';

import {MainContentLoader} from '@udemy-v2/react-reveal-components';

/**
 * Suspense fallback for the streamed profile sections.
 *
 * `@udemy-v2/react-reveal-components` ships without a `'use client'` directive
 * and transitively imports `@udemy-v2/i18n` (which calls `createContext`), so
 * importing `MainContentLoader` straight into the Server Component page pulls it
 * into the RSC graph and throws "createContext only works in Client Components".
 * This thin client wrapper keeps that import on the client side of the boundary.
 */
export function SectionLoader() {
    return <MainContentLoader />;
}
